import { render, staticRenderFns } from "./widthCards.vue?vue&type=template&id=78bef184&"
import script from "./widthCards.vue?vue&type=script&lang=js&"
export * from "./widthCards.vue?vue&type=script&lang=js&"
import style0 from "./widthCards.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports